import { gql } from '@apollo/client';

export default gql`
  query previewInfo {
    previewInfo {
      key
      expiredAt
    }
  }
`; 